import { FC } from 'react';
import { Link } from 'react-router-dom';
import { tailwindOverride } from '@getsynapse/design-system';
import TruncatedTableColumn from 'Pages/ProjectsListPage/components/ActiveProjects/components/TruncatedTableColumn/TruncatedTableColumn';

interface LinkTableRowCellProps {
  value: string;
  to: string;
  className?: string;
}

export const LinkTableRowCell: FC<LinkTableRowCellProps> = ({
  value,
  to,
  className = '',
}) => {
  return (
    <div className='w-full'>
      <TruncatedTableColumn
        value={value}
        content={
          <Link
            to={to}
            className={tailwindOverride(
              'text-left leading-5 w-full ',
              'hover:underline hover:text-steel-blue hover:font-semibold',
              'focus:underline focus:text-steel-blue focus:font-semibold focus:outline-none',
              'focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-1',
              'cursor-pointer',
              'no-underline',
              className
            )}
            aria-label={`Navigate to ${value} details`}
          >
            {value}
          </Link>
        }
        className={className}
      />
    </div>
  );
};
